<template>
  <div class="md-layout">
    <div v-if="!userId"
        id="objectHeaderContentHidden" style="display: none;">
      <div>
        <md-icon class="icon-color">{{list.pageIcon}}</md-icon>
      </div>
      <div>
        <h1 class="md-title icon-color">{{ $route.name }}</h1>
      </div>
    </div>

    <div class="md-layout-item">
      <TasksFilter :userId="userId" v-model="filterModel" :atSearch="onTaskFilterSubmit" :csvItems="taskItems" :csvColumns="list.columns" />
      <ElasticList v-if="!userId" :list="list" :rawFilter="applyTasksFilter" ref="tasksListRef"></ElasticList>
      <ElasticList v-else :list="list" :userId="userId" :excludeColumns="'assignee'" :rawFilter="applyTasksFilter" ref="tasksListRef"></ElasticList>
    </div>
  </div>
</template>

<script>
import ElasticList from "@/components/DynamicForm/ElasticList";
import TasksFilter from "@/pages/Tasks/Filter/TasksFilter";
import moment from 'moment';
export default {
  props: {
    userId: {
      type: String,
      required: false,
      default: ""
    }
  },
  components: {
    ElasticList,
    TasksFilter,
  },
  computed: {
    applyTasksFilter() {
      let range = [];
      let filter = [];
      let mustNotFilter = [{ match: { isTemplate: true }}];
      let tasksFilter = { isTemplate: { ne: true }};
      if (!this.$Session.isInternalGroupMember) {
        tasksFilter.internal = { ne: true };
      }

      if (!this.$Session.isInternalGroupMember) {
        mustNotFilter.push({ term: { internal: true } });
      }

      // filter taks by assignee
      const selectedAssigneeIds = this.filterTaskAssignee(this.userId);
      const dueWhen = this.filterModel.dueWhen;

      if ('completed' == dueWhen) {
        filter.push({"match": {"status": 'Completed' }}) 
        const model = this.filterModel;
        range.push({"range":{"dateDue":{"time_zone":"+00:00","gte":model.dueDateFrom,"lte":model.dueDateTo}}})
      }

      if ('next_7_days' == dueWhen) {
        mustNotFilter.push({"match": {"status": 'Completed'}},{"match": {"status": 'Closed_By_Workflow'}}) 
        let d = new Date();
        let toDate = new Date(d.setDate(d.getDate()+7));      
        range.push({"range":{"dateDue":{"time_zone":"+00:00","gte":"now","lte":toDate}}})
      }

      if ('open' == dueWhen) {
        mustNotFilter.push({"match": {"status": 'Completed'}},{"match": {"status": 'Closed_By_Workflow'}}) 
      }

      if ('today_overdue' == dueWhen) {
        mustNotFilter.push({"match": {"status": 'Completed'}},{"match": {"status": 'Closed_By_Workflow'}})    
        range.push({"range":{"dateDue":{"time_zone":"+00:00","lte":"now"}}})
      }

      if ('tomorrow' == dueWhen) {
        mustNotFilter.push({"match": {"status": 'Completed'}},{"match": {"status": 'Closed_By_Workflow'}}) 
        let d = new Date();
        let toDate = new Date(d.setDate(d.getDate()+1));      
        range.push({"range":{"dateDue":{"time_zone":"+00:00","gte":"now","lte":toDate}}})        
      }

      if(mustNotFilter.length){
        return { filter: {esQuery: JSON.stringify
          ({"bool":
            {
              "must_not": mustNotFilter,
              "must":[{"bool":{"should":selectedAssigneeIds}},
                      {"bool":{"should":filter}},
                      {"bool":{"should":range}}                                            
                     ]          
            }
          })
        },
          tasksFilter         
        }   
      }               
    },
  },
  data() {
    return {
      filterModel: {},
      taskItems: [],
      list: {
        hideListHeader: true,
        editPath: "tasks",
        pageTitle: "Tasks",
        pageIcon: "assignment_ind",
        listQueryId: "searchTaskStepsListCustoms",
        linkRows: false,
        linkConfigs: [
          {
            name: 'subject',
            hrefCallback: (column, name, item) => {
              return '#/tasks/' + item.id;
            },
            titleCallback: (column, name, item) => {
              return item.subject;
            },
          },
          {
            name: 'caseSubject',
            hrefCallback: (column, name, item) => {
              return '#/cases/' + this.$reduce(item, 'case.id');
            },
            titleCallback: (column, name, item) => {
              return item.caseSubject;
            },
          },
          {
            name: 'serviceName',
            hrefCallback: (column, name, item) => {
              return '#/services/' + this.$reduce(item, 'services.items.0.service.id');
            },
            titleCallback: (column, name, item) => {
              return item.serviceName;
            },
          },
        ],
        deleteQueryId: "deleteTask",
        deleteRelatedRecord: {
          record: [
            { deleteSyncQueryId: "deleteTaskStep", relatedModelItem: 'steps' }
          ]
        },
        deleteMessageNameFields: ['subject'],
        responseFieldName: "searchTasks",
        columns: {
          subject: { label: "Subject", sortable: true },
          caseSubject: { label: "Case", sortable: false },
          serviceName: { label: "Service", sortable: false },
          mid: { label: "MID", sortable: false },
          quickNote: { label: "Quick Note", sortable: true },
          dateOpen: { label: "Date Opened", sortable: true, sortKey: 'dateOpenOrig' },
          dateDue: { label: "Due Date", sortable: true, sortKey: 'dateDueOrig' },
          status: { label: "Status", sortable: true },
          templateType: { label: "Type", sortable: false },
          salesRepName: { label: "Sales Rep", sortable: false },
          priority: { label: "Priority", sortable: true },
          assignee: { label: "Assignee", sortable: true },
          createdAt: { label: "Created At", sortable: true },
          updatedAt: { label: "Last Modifed", sortable: true },
        },
        ignoreSortColumns: [
          'subject',
          'caseSubject',
          'serviceName',
          'mid',
          'quickNote',
          'dateOpen',
          'dateDue',
          'status',
          'templateType',
          'salesRepName',
          'priority',
          'assignee',
        ],
        addDefaultSortIfNone: true,
        searchRecordsInput: true,
        perPageOptions: [5, 10, 20, 25, 50],
        defaults: {
          sort: "createdAt",
          sortDir: "desc",
          perPage: 10,
          limit: 99,
          customFieldSort: true //to allow dateDue sorting
        },
        fuseSearch: null,
        // addonFilters: [
        //   {
        //     id: 'taskUserId',
        //     query: 'listUsers',
        //     key: 'id',
        //     label: 'name',
        //     labelFormatter: (option) => {
        //       return `${option.given_name} ${option.family_name}`;
        //     },
        //     optionsFilter: (option) => {
        //       return option.tasks && option.tasks && option.tasks.items && option.tasks.items.length;
        //     },
        //     placeholder: 'Filter Assignee',
        //     modal: '',
        //     value: '',
        //   },
        //   {
        //     id: 'status',
        //     query: 'listTaskStatusEnum',
        //     queryOptionsKey: 'enumValues',
        //     key: 'name',
        //     label: 'name',
        //     placeholder: 'Filter Status',
        //     modal: '',
        //     value: '',
        //   },
        // ],
        formatResponse: (data) => {
          let result = [];
            if (data && data.searchTasks && data.searchTasks.items.length) {
              
              data.searchTasks.items.forEach((item) => {

                // add case subject
                item.caseSubject = this.$reduce(item, 'case.subject') || '';

                // add type
                item.templateType = this.$reduce(item, 'type') || '';

                // add case subject
                item.serviceName = this.$reduce(item, 'services.items.0.service.name') || '';

                // add MID
                item.mid = this.$reduce(item, 'services.items.0.service.merchantNumber') || '';

                // add dateOpen
                item.dateOpen = item.createdAt;
                if (item.dateOpen && moment(item.dateOpen).isValid()) {
                  item.dateOpenOrig = moment(item.dateOpen).toDate().toISOString();
                  item.dateOpen = moment(item.dateOpen).format('MMM DD, YYYY')
                } else {
                  item.dateOpenOrig = '';
                  item.dateOpen = '';
                }

                // add sales rep name
                const salesRep = this.$reduce(item, 'salesreps.items.0.salesrep');
                if (salesRep) {
                  item.salesRepName = `${salesRep.given_name} ${salesRep.family_name}`;
                }

                if(item.user != null) {
                  item.assignee = item.user.given_name + " " + item.user.family_name;
                } else {
                  item.assignee = 'Unassigned';
                }
                if(item.dateDue) {
                  //convert dateDue to ISO string for sorting on list control
                  if(moment(item.dateDue).isValid()) {
                    item.dateDueOrig = moment(item.dateDue).toDate().toISOString();
                    item.dateDue = moment(String(item.dateDue)).format('MMM DD, YYYY')
                  }else {
                    item.dateDueOrig = '';
                    item.dateDue = '';
                  }                  
                } 
                else {
                  item.dateDueOrig = '';
                  item.dateDue = '';
                }
                if(item.quickNote){
                  item.quickNote = item.quickNote.substring(0, 30);;
                }     
                else{
                  item.quickNote = '';
                }                                             
                result.push(item);
              })
            }

          if (result && result.length) {
            const tasksListRef = this.$refs.tasksListRef;
            const sortOrder = tasksListRef.currentSortDir;

            let sortKey = this.$reduce(this, `list.columns.${tasksListRef.currentSort}.sortKey`);
            if (!sortKey) {
              sortKey = tasksListRef.currentSort;
            }

            result = _.sortBy(result, sortKey);
            if ('desc' == sortOrder) {
              result = result.reverse();
            }
          }

          this.taskItems = result;
          return result;
        }
      }
    };
  },
  methods: {
    /**
     * Search using task filter form options
     * @return {void}
     */
    onTaskFilterSubmit() {
      this.$refs.tasksListRef.refresh();
    },
    /**
     * Filter tasks by selected assignees in task filter form   
     */
    filterTaskAssignee(userIdOverride) {
      let selectedAssigneeIds = [];

      if (userIdOverride) {
        selectedAssigneeIds = [{ match: { taskUserId: userIdOverride } }];
      } else {
        // get selected assignees
        const selectedAssignees = this.$reduce(this, 'filterModel.assignees');

        if(selectedAssignees && selectedAssignees.length) {
          selectedAssignees.forEach((_assignee) => {
            selectedAssigneeIds.push({match: {taskUserId: _assignee.id}});
          });
        }

      }

      return selectedAssigneeIds
    },
    /**
     * Filter out tasks by the specified field and date range
     * @param  {Array} tasks 
     * @param  {String} dateField date filed to filter records by
     * @param  {String} dateFrom start date
     * @param  {String} dateTo end date
     * @return {Array}
     */
    filterTasksByDateField(tasks, dateField, dateFrom, dateTo) {
      let items = tasks;
      
      // filter any tasks with invalid dateField value
      if (dateFrom || dateTo) {
        items = tasks.filter(_task => {
          try {
            return _task[dateField] && moment(_task[dateField]).isValid()
          } catch (e) {
            return false;
          }
        });
      }

      // filter from date
      if (dateFrom) {
        items = items.filter(_task => {
          const sourceDate = moment(_task[dateField]).startOf('day');
          const targetDate = moment(dateFrom).startOf('day');
          return sourceDate.isSameOrAfter(targetDate);
        });
      }
      
      // filter to date
      if (dateTo) {
        items = items.filter(_task => {
          const sourceDate = moment(_task[dateField]).startOf('day');
          const targetDate = moment(dateTo).startOf('day');
          return sourceDate.isSameOrBefore(targetDate);
        });
      }

      return items;
    },
    /**
     * Filter out any task which is not in [Completed, Closed_By_Workflow]
     * @return {Array}
     */
    filterPendingTasks(tasks) {
      return tasks.filter(_task => {
        if (!_task.status) {
          return true;
        }
        return -1 === ['completed', 'closed_by_workflow'].indexOf(_task.status.toLowerCase());
      });
    },
    /**
     * Filter completed tasks - ATLAS-874 - 3(b)(ii)(1)
     * @see https://zeamster.atlassian.net/browse/ATLAS-874
     * @return {Array}
     */
    filterCompletedTasks(tasks) {
      const items = tasks.filter(_task => {
        return _task.status && 'completed' == _task.status.toLowerCase();
      });
      const model = this.filterModel;
      return this.filterTasksByDateField(items, 'dateDue', model.dueDateFrom, model.dueDateTo);
    },
    /**
     * Filter tasks due in next 7 days
     * @param  {Array} tasks
     * @return {Array}
     */
    filterDueTasksInNext7Days(tasks) {
      const items = this.filterPendingTasks(tasks);
      return this.filterTasksByDateField(items, 'dateDue', moment(), moment().add(7, 'days'));
    },
    /**
     * Filter open tasks - no due date consideration
     * @param  {Array} tasks
     * @return {Array}
     */
    filterOpenTasks(tasks) {
      return this.filterPendingTasks(tasks);
    },
    /**
     * Filter tasks due today or any day prior
     * @param  {Array} tasks
     * @return {Array}
     */
    filterDueTodayAndEarlierTasks(tasks) {
      const items = this.filterPendingTasks(tasks);
      return this.filterTasksByDateField(items, 'dateDue', null, moment());
    },
    /**
     * Filter tasks with a dueDate of tomorrow
     * @param  {Array} tasks
     * @return {Array}
     */
    filterDueTomorrowTasks(tasks) {
      const items = this.filterPendingTasks(tasks);
      const tomorrow = moment().add(1, 'days');
      return this.filterTasksByDateField(items, 'dateDue', tomorrow, tomorrow);
    }
  }
};
</script>

<style></style>
